import warehouseHtmxDefaults from '../shopify-warehouse-htmx/config.js';
import shopifyWarehouseGenericDefaults from '../shopify-warehouse-generic/config.js';

export default {
  ...warehouseHtmxDefaults,
  includes: ['shopify-warehouse-generic', 'shopify-warehouse-htmx'],
  Widgets: [
    ...warehouseHtmxDefaults.Widgets,
    ...shopifyWarehouseGenericDefaults.Widgets.filter((w) =>
      ['RelatedItems', 'BoughtTogether'].includes(w.name),
    ),
  ],
};
